import { render, staticRenderFns } from "./TestPrepPerformance.vue?vue&type=template&id=cae9f0ba&scoped=true"
import script from "./TestPrepPerformance.vue?vue&type=script&lang=js"
export * from "./TestPrepPerformance.vue?vue&type=script&lang=js"
import style0 from "./TestPrepPerformance.vue?vue&type=style&index=0&id=cae9f0ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae9f0ba",
  null
  
)

export default component.exports